import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import TechnicalConsultation from "./sections/TechnicalConsultation";
import CommonQuestions from "./sections/CommonQuestions";
import OfficeLocations from "./sections/OfficeLocations";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <TechnicalConsultation />
      <CommonQuestions />
      <OfficeLocations />
      <Footer />
    </div>;
}